Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowRightLargeData: "data:image/svg+xml,%3csvg width='14' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M9 9l4-4-4-4M13 5H1'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowRightLargeRtlSvg: "data:image/svg+xml,%3csvg width='14' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M1 5h12'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowRightLargeWidth: 14,
  iconArrowRightLargeHeight: 10
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/base/icon/arrow-right-large.js
// module id = 120
// module chunks = 0